import { render, staticRenderFns } from "./task-settings-view.vue?vue&type=template&id=4b20405d"
import script from "./task-settings-view.vue?vue&type=script&lang=js"
export * from "./task-settings-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports